import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { copy } from '@/copy';

const SignOutButton = ({ className = '', 'data-testid': testId, ...rest }) => {
  const { logout } = useAuth();

  const handleSignOut = () => {
    // Clear token + auth state, then hard-redirect to the landing page.
    // window.location.replace bypasses React Router so a still-mounted
    // ProtectedRoute can't race a redirect to /login, fully resets in-memory
    // state, and replaces the history entry (Back won't return to authed pages).
    logout();
    window.location.replace('/');
  };

  return (
    <button
      type="button"
      onClick={handleSignOut}
      data-testid={testId || 'sign-out-button'}
      aria-label={copy.nav.signOut}
      className={`inline-flex items-center gap-1.5 rounded-full bg-[#1D2D44] px-3 py-1.5 text-sm text-[#F5F5F5] transition-colors duration-200 hover:text-[#C9A84C] focus:outline-none focus:ring-2 focus:ring-[#C9A84C]/40 ${className}`}
      {...rest}
    >
      <LogOut className="w-3.5 h-3.5" strokeWidth={1.75} />
      <span>{copy.nav.signOut}</span>
    </button>
  );
};

export default SignOutButton;
